module.exports = __webpack_public_path__ + "static/media/1POLICY26.0f897d28.jpg";